import {CampaignFilter} from '@dms/api/shared';

import {VehicleSelectionMode} from '../../../types/VehicleSelectionMode';
import {compactVehicleSelectionFilter} from '../../../utils/compactVehicleSelectionFilter';
import {WatermarkFormType} from '../types/WatermarkFormType';

// "By conditions" sends its compacted rules; "all vehicles" sends null.
export const getWatermarkVehicleSelection = (
  data: Pick<WatermarkFormType, 'vehicleSelectionMode' | 'filter'>
): CampaignFilter | null =>
  data.vehicleSelectionMode === VehicleSelectionMode.BY_CONDITIONS
    ? compactVehicleSelectionFilter(data.filter)
    : null;
